import { UserCallAvailability } from "@redotech/redo-support-common/support/voice/voice-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getTeamCallAvailabilities = {
  name: "getTeamCallAvailabilities" as const,
  input: z.object({}),
  output: z.object({
    callAvailabilities: z.array(
      z.object({
        userId: z.string(),
        availability: createEnum(UserCallAvailability),
      }),
    ),
  }),
};
